import {Button, Checkbox} from '@sportcast/ui-react';
import {useState} from 'react';
import {Modal} from 'react-bootstrap';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import {acceptTermsOfUse} from '../../fetch/accountApi';
import {loggedIn} from '../../redux/slice/loginSlice';
import {RootState, useAppDispatch} from '../../store';
import {UserType} from '../../types/UserType';
import {formatDate} from '../../util/DateUtil';
import TermsOfUseHeader from '../common/legal-infos/TermsOfUseHeader';
import TermsOfUseText from '../common/legal-infos/TermsOfUseText';
import './DataPrivacyAcceptanceModal.scss';

interface TermsOfUseAcceptanceModalProps {
    show: boolean;
    onClose: () => void;
}

const TermsOfUseAcceptanceModal = (props: TermsOfUseAcceptanceModalProps) => {
    const dispatch = useAppDispatch();
    const [t] = useTranslation();
    const userData = useSelector((state: RootState) => state.login.userData);
    const [hasAccepted, setHasAccepted] = useState(!!userData?.termsOfUseAcceptanceDate);
    const userIsRePortUser = useSelector((state: RootState) => !!state.login.userData?.id);

    const handleClick = () => {
        acceptTermsOfUse(dispatch).then(response => {
            if (!!response && !!response.result) {
                dispatch(loggedIn({...userData, termsOfUseAcceptanceDate: formatDate(new Date(Date.now()))} as UserType));
                props.onClose();
            }
        });
    };

    return (
        <Modal show={props.show} className="data-privacy-modal" onHide={props.onClose}>
            <Modal.Header closeButton={!userIsRePortUser}>
                <TermsOfUseHeader/>
            </Modal.Header>
            <Modal.Body>
                <TermsOfUseText/>
            </Modal.Body>
            {
                userIsRePortUser &&
                <Modal.Footer className="data-privacy-footer">
                    <Checkbox
                        id="accept-data-privacy"
                        label={t('DataPrivacy.I_ACCEPT_DATA_PRIVACY')}
                        value={hasAccepted}
                        onChange={setHasAccepted}/>
                    <Button
                        id="close-data-privacy-modal"
                        className="float-end"
                        label={t('button.CLOSE')}
                        disabled={!hasAccepted}
                        onClick={handleClick}/>
                </Modal.Footer>
            }
        </Modal>
    );
};

export default TermsOfUseAcceptanceModal;
